var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.prompt_obj && _vm.tips_modal)?_c('div',[_c(_vm.getPrompt(),{ref:"prompt-component",tag:"component",attrs:{"parentData":{ prompt: _vm.prompt_data }},on:{"close-modal":_vm.closePrompt}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }